import React, { useState, createContext, useContext } from 'react'

export const ListingDetailContext = createContext()

export const useListingDetailContext = () => useContext(ListingDetailContext)

export const ListingDetailProvider = props => {
  const { data: fetchedData, children } = props
  const [data, setData] = useState(fetchedData || {})
  const { route = '', listing = {}, queryParams = {} } = data

  return (
    <ListingDetailContext.Provider
      value={{
        route,
        listing,
        queryParams: {
          ...queryParams,
          path: queryParams.base_path,
        },
        setData,
      }}
    >
      {children}
    </ListingDetailContext.Provider>
  )
}
